interface IObject {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export default class ObjectUtils {
  // eslint-disable-next-line max-len
  static removeUndefinedProps = (obj: IObject): IObject => Object.keys(obj).reduce((acc: IObject, key) => {
    if (obj[key] !== undefined) acc[key] = obj[key];
    return acc;
  }, {});

  static countTruthyFields(obj: IObject): number {
    return Object.keys(obj).reduce((acc: number, key) => (obj[key] ? acc + 1 : acc), 0);
  }

  static isObject(item: IObject): boolean {
    return (item && typeof item === 'object' && !Array.isArray(item) && item !== null);
  }

  static isEmpty(item: IObject): boolean {
    return !item || Object.keys(item).length === 0;
  }

  /**
   * Deep merge two objects.
   */
  static mergeDeep(target: IObject, source: IObject): IObject {
    if (ObjectUtils.isObject(target) && ObjectUtils.isObject(source)) {
      Object.keys(source).forEach(key => {
        // Check for potential prototype pollution keys
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return;
        }

        if (ObjectUtils.isObject(source[key])) {
          if (!target[key] || !ObjectUtils.isObject(target[key])) {
            /* eslint-disable-next-line no-param-reassign */
            target[key] = source[key];
          }
          ObjectUtils.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      });
    }
    return target;
  }
}
